<template>
  <div>
    <h3  style="text-align: center;">DECLARACIÓN ORIGEN DE FONDOS</h3> 
    <p>Obrando en nombre propio de manera voluntaria y dando certeza de que todo lo que aquí consignado es cierto,
realizo la siguiente declaración de fuente de fondos de La Fundación de Apoyo a la Educación y Fomento
Empresarial, con el propósito de que se pueda dar cumplimiento a lo señalado al respecto en la circular 007 de julio
30 de 1997 sobre mecanismos de prevención y control de activos.</p>
<ol>
  <li>Los recursos que entregue en depósito provienen de las actividades registradas en el formulario de solicitud.</li>
  <li>Declaro que los recursos que entregue no provienen de ninguna actividad ilícita de las contempladas en el Código Penal Colombiano o en cualquier forma que lo modifique o adicione.</li>
  <li>No admitiré que terceros efectúen depósitos a mis cuentas con fondos provenientes de las actividades ilícitas
contempladas en el Código Penal Colombiano.</li>
</ol>
<p></p>
<p>Autorizo a saldar las cuentas y depósitos que mantenga en esta institución, en el caso de infracción de cualquiera
de los numerales contenidos en este documento, eximiendo a La Fundación Apoyo de toda responsabilidad que se
derive por información errónea, falsa o inexacta que yo hubiere proporcionado en este documento, o de la
violación del mismo.</p>
  </div>
</template>

<script>
export default {
  name: 'aporte_titulo_donacion',
  data () {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>